import { SVGProps } from 'react';
import { ReactComponent } from 'icons/eye-hide.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
const EyeHideIcon = (props: Props) => {
  // eslint-disable-next-line
  return <ReactComponent {...props} />;
};

export default EyeHideIcon;
